import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useParseRouteActions,useFetchData } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
import { IdProps } from "../../interfaces/Global";
import { LmsEndpoints } from "../../constants/LmsEndpoints";

const LmsReportsTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="menu/borrower-vendor"
    useApiFiltering
  />;
};

const addLmsBorrowerVendorFormFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Borrower", LmsEndpoints.Orgs.GET.LIST_USER_ORGANIZATIONS, { required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Name", { required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Address", { required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("City", { required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("State", { required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Zip", { required: true })]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", { inline: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description")]); 
  return myForm;
};

const AddLmsBorrowerVendorForm = () => {
  const myForm = addLmsBorrowerVendorFormFields(new BCFormController({ isActive: true }, { submitSuffix: "menu/borrower-vendor" }));
  const formActions = ["save-new","save-continue","save-close","close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const EditLmsBorrowerVendorForm = ({ id = "" }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`${id}`);
  const myForm = addLmsBorrowerVendorFormFields(new BCFormController(data, { initIsDisabled: true, submitSuffix: "menu/borrower-vendor" }));
  const formActions = ["save", "save-close", "delete", "close"];
  return (<LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} />);
};

const LmsNewMenusBorrowerVendor = ({ params = {}, history }) => {
  const allowedActions = ["add"];
  const { isAdd, isEdit, isMainPage, isActionAllowed, id } = useParseRouteActions(params, allowedActions);  
  if (!isActionAllowed) {
    history.goBack();
  }

  return <>
    {isMainPage && <LmsReportsTable />}
    {isAdd && <AddLmsBorrowerVendorForm />}
    {isEdit && <EditLmsBorrowerVendorForm id={id} />}
  </>;
};

export default LmsNewMenusBorrowerVendor;